import {XeroConfigurationRequest} from '../models/xero/xeroConfiguration.model';

export namespace Xero {
  export class GetConfiguration {
    static readonly type = '[Xero api] Get Configuration';
    constructor(public force: boolean = false) {}
  }

  export class CreateConfiguration {
    static readonly type = '[Xero api] Create Configuration';
    constructor(public request: XeroConfigurationRequest) {}
  }

  export class UpdateConfiguration {
    static readonly type = '[Xero api] Update Configuration';
    constructor(public id: string, public request: XeroConfigurationRequest) {}
  }

  export class GetAuthUrl {
    static readonly type = '[Xero api] Get Auth URL';
  }

  export class HandleCallback {
    static readonly type = '[Xero api] Handle Callback';
    constructor(public code: string, public state: string) {}
  }

  export class GetTenants {
    static readonly type = '[Xero api] Get Tenants';
  }

  export class SelectTenant {
    static readonly type = '[Xero api] Select Tenant';
    constructor(public configId: string, public tenantId: string) {}
  }

  export class GetXeroAccounts {
    static readonly type = '[Xero api] Get Xero Accounts';
  }

  export class GetTaxRates {
    static readonly type = '[Xero api] Get Tax Rates';
  }

  export class GetSyncLogs {
    static readonly type = '[Xero api] Get Sync Logs';
    constructor(public force: boolean = false) {}
  }

  export class SyncContact {
    static readonly type = '[Xero api] Sync Contact';
    constructor(public accountId: string) {}
  }

  export class SyncQuote {
    static readonly type = '[Xero api] Sync Quote';
    constructor(public jobId: string) {}
  }

  export class SyncInvoice {
    static readonly type = '[Xero api] Sync Invoice';
    constructor(public jobId: string) {}
  }

  export class SyncBills {
    static readonly type = '[Xero api] Sync Bills';
    constructor(public jobId: string) {}
  }

  export class SyncCreditNote {
    static readonly type = '[Xero api] Sync Credit Note';
    constructor(public creditNoteId: string) {}
  }

  export class RetryFailedSyncs {
    static readonly type = '[Xero api] Retry Failed Syncs';
  }
}
